import React from 'react';

// eslint-disable-next-line import/namespace, import/default, import/no-named-as-default, import/no-named-as-default-member
import VersionService from '@qality/common-service/src/VersionService';

import { ProjectVersionContext } from './ProjectVersionContext';

export interface ProjectVersionProviderProps {
  children: React.ReactNode;
}

export const ProjectVersionProvider: React.FC<ProjectVersionProviderProps> = ({
  children,
}: ProjectVersionProviderProps) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [projectVersionList, setProjectVersionList] = React.useState<
    {
      name: string;
      projectId: string;
      id: string;
    }[]
  >(null);

  const fetchProjectVersion = async (projectId: string) => {
    const projectVersionsList = await VersionService.getVersions(projectId);

    setProjectVersionList(projectVersionsList);

    setIsLoading(false);
  };

  return (
    <ProjectVersionContext.Provider
      value={{
        fetchProjectVersion,
        isFetchingProjectVersion: isLoading,
        projectVersionList,
      }}
    >
      {children}
    </ProjectVersionContext.Provider>
  );
};
